<template>
    <div>
        <v-card-actions>
            <v-container>
                <v-row>
                    <v-col cols="2">
                        <v-text-field
                            class=""
                            inputmode="text"
                            label="名称"
                            v-model="searchWord"
                        />
                    </v-col>
                    <v-col cols="2">
                        <v-btn
                            :disabled="btn[1].isActive"
                            color="primary"
                            dark
                            class=""
                            v-on:click="clickSearch">検索</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-actions>
        <v-data-table
            :headers="headers"
            :items="desserts"
            hide-default-footer
            class="col-12"
            disable-pagination
        >
            <template v-slot:[`item.name`]="{ item }">
                <v-text-field v-model="item.name"/>
            </template>
            <template v-slot:[`item.ip`]="{ item }">
                <v-text-field v-model="item.ip"/>
            </template>
            <template v-slot:[`item.btn_key`]="{ item }">
                <v-btn
                    :disabled="btn[4].isActive"
                    text
                    color="primary"
                    @click="comfirmUpdate(item)">キー登録</v-btn>
            </template>
            <template v-slot:[`item.btn_delete`]="{ item }">
                <v-btn
                    :disabled="btn[3].isActive"
                    text
                    color="primary"
                    @click="comfirmDelete(item)">削除</v-btn>
            </template>
        </v-data-table>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                :disabled="btn[2].isActive"
                color="green darken-4"
                text
                @click="addRecord">追加</v-btn>
        </v-card-actions>
        <v-overlay :value="keyUpdate">
            <v-card light width="500px">
                <v-card-title v-if="result === 0">APIキー登録の最終確認</v-card-title>
                <v-card-title v-if="result >= 1">APIキー登録</v-card-title>
                <v-card-text v-if="result === 0">新しいAPIキーを登録します。元には戻せません。</v-card-text>
                <v-card-text>{{ resultText }}</v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="result === 0" color="primary" text @click="keyUpdate = !keyUpdate">キャンセル</v-btn>
                    <v-btn v-if="result === 0" color="primary" text @click="updateApiKey(data)">登録する</v-btn>
                    <v-btn v-if="result === 1" color="primary" text @click="closeKeyUpdate()">閉じる</v-btn>
                    <v-btn v-if="result > 1" color="primary" text @click="keyUpdate = !keyUpdate">閉じる</v-btn>
                </v-card-actions>
            </v-card>
        </v-overlay>
        <v-overlay :value="keyDelete">
            <v-card light width="500px">
                <v-card-title v-if="result === 0">APIキー削除の最終確認</v-card-title>
                <v-card-title v-if="result >= 1">APIキー削除</v-card-title>
                <v-card-text v-if="result === 0">APIキーを削除します。元には戻せません。</v-card-text>
                <v-card-text>{{ resultText }}</v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="result === 0" color="primary" text @click="keyDelete = !keyDelete">キャンセル</v-btn>
                    <v-btn v-if="result === 0" color="primary" text @click="deleteApiKey(data)">削除する</v-btn>
                    <v-btn v-if="result === 1" color="primary" text @click="closeKeyDelete()">閉じる</v-btn>
                    <v-btn v-if="result > 1" color="primary" text @click="keyDelete = !keyDelete">閉じる</v-btn>
                </v-card-actions>
            </v-card>
        </v-overlay>
        <v-overlay :value="showError">
            <v-card light width="500px">
                <v-card-title>APIキー登録</v-card-title>
                <v-card-text>{{ resultText }}</v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="showError = false">閉じる</v-btn>
                </v-card-actions>
            </v-card>
        </v-overlay>
    </div>
</template>

<script>
// mixins
import { authorityMixin } from '@/views/authorityMixin';

// graghql
import {
    GET_API_KEYS,
    REGIST_API_KEY,
    DELETE_API_KEY
} from '@/constants/apikey';

export default {
    mixins: [authorityMixin],
    data () {
        return {
            golf_code: '',
            // v-data-tableのヘッダー
            headers: [
                { text: '名称', value: 'name', sortable: false, align: 'center' },
                { text: 'IP', value: 'ip', sortable: false },
                { text: 'APIキー', value: 'api_key', sortable: false, width: 400 },
                { text: '', value: 'btn_key', sortable: false },
                { text: '', value: 'btn_delete', sortable: false }
            ],
            desserts: [],
            keyUpdate: false,
            keyDelete: false,
            showError: false,
            result: false,
            resultText: '',
            searchWord: '',
            data: [],
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '検索', isActive: true },
                { element_id: '002', element_name: '追加', isActive: true },
                { element_id: '003', element_name: '削除', isActive: true },
                { element_id: '004', element_name: 'キー登録', isActive: true }
            ],
            vue_id: 'SCR0031'
        };
    },
    created () {
        this.Initialize();
    },
    methods: {
        async Initialize () {
            this.admin = await this.getLoginAdmin();
            this.getAuthorityList();
            this.getData();
        },
        clickSearch () {
            this.getData();
        },
        getData () {
            try {
                this.$store.commit('loading/setIsLoading', true);
                this.$apollo.query({
                    query: GET_API_KEYS,
                    fetchPolicy: 'no-cache',
                    variables: {
                        searchWord: this.searchWord
                    }
                }).then(res => {
                    this.desserts = res.data.GetApiKeys.ApiKyeLists;
                });
                this.$store.commit('loading/setIsLoading', false);
            } catch (error) {
                this.resultText = error;
                this.$store.commit('loading/setIsLoading', false);
            }
        },
        addRecord () {
            const someKey = this.desserts.findIndex(el => el.id === '');
            if (someKey === -1) {
                this.desserts.push({ id: '', name: '', ip: '', api_key: '' });
                this.$nextTick(() => {
                    var container = this.$el.querySelector('.v-data-table');
                    container.scrollTop = container.scrollHeight;
                });
            } else {
                this.result = 9;
                this.resultText = '登録されていないデータがあります。';
                this.showError = true;
            }
        },
        updateApiKey (item) {
            try {
                this.$store.commit('loading/setIsLoading', true);
                this.$apollo.mutate({
                    mutation: REGIST_API_KEY,
                    variables: {
                        id: item.id,
                        name: item.name,
                        ip: item.ip
                    }
                }).then(res => {
                    this.result = res.data.RegistApiKey.result;
                    if (this.result === 8) {
                        this.resultText = '名称、IPが重複しています。';
                    } else if (this.result === 9) {
                        this.resultText = 'エラーが発生しました。';
                    } else {
                        this.resultText = '正常終了しました。';
                    }
                });
                this.$store.commit('loading/setIsLoading', false);
            } catch (error) {
                this.resultText = error;
                this.$store.commit('loading/setIsLoading', false);
            }
        },
        comfirmUpdate (item) {
            this.result = 0;
            this.resultText = '';
            this.checkInputData(item);
        },
        checkInputData (item) {
            if (item.name && item.ip) {
                this.data = item;
                this.keyUpdate = true;
            } else {
                this.result = 9;
                this.resultText = '名称とIPの両方を入力してください。';
                this.showError = true;
            }
        },
        checkDeleteData (item) {
            if (item.id === '') {
                this.desserts.pop();
            } else {
                this.data = item;
                this.keyDelete = true;
            }
        },
        deleteApiKey (item) {
            try {
                this.$store.commit('loading/setIsLoading', true);
                this.$apollo.mutate({
                    mutation: DELETE_API_KEY,
                    variables: {
                        id: item.id
                    }
                }).then(res => {
                    this.result = res.data.DeleteApiKey.result;
                    if (this.result === 9) {
                        this.resultText = 'エラーが発生しました。';
                    } else {
                        this.resultText = '正常終了しました。';
                    }
                });
                this.$store.commit('loading/setIsLoading', false);
            } catch (error) {
                this.resultText = error;
                this.$store.commit('loading/setIsLoading', false);
            }
        },
        comfirmDelete (item) {
            this.result = 0;
            this.resultText = '';
            this.checkDeleteData(item);
        },
        closeKeyUpdate () {
            this.Initialize();
            this.keyUpdate = false;
        },
        closeKeyDelete () {
            this.Initialize();
            this.keyDelete = false;
        }
    }
};
</script>

<style scoped>
.v-data-table{
    overflow-y: scroll;
    min-height: 200px;
    max-height: 600px;
}
</style>
